module.exports = __webpack_public_path__ + "img/logo-ic-s-rubom.da2fb0a3.png";